import React, { FC, useEffect } from 'react';
import { authStore } from '@store/auth';
import { getManagerApiUrl } from '@models/Auth';
import styles from './ApiDocsButton.module.scss';

const SWAGGER_AUTH_PATH = '/swagger-auth';

// Opens the access server's Swagger UI in a new tab. Submits the held manager token via a cross-site form POST (SAML-style); the server turns it into a first-party X-API-KEY cookie and redirects into the docs. A form POST (not fetch) keeps the token out of the URL and avoids third-party-cookie blocks, since the cookie is written during a top-level navigation.
export const ApiDocsButton: FC = () => {
    // Warm the HTTPS manager port cache so the click handler stays synchronous (an await there would
    // drop the user-gesture context and let popup blockers kill the new tab).
    useEffect(() => {
        authStore.resolveManagerApiUrl().catch(() => {});
    }, []);

    const openApiDocs = () => {
        if (!authStore.wsUrl || !authStore.token) return;

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = `${getManagerApiUrl(authStore.wsUrl, authStore.httpsManagerPort)}${SWAGGER_AUTH_PATH}`;
        form.target = '_blank';
        form.setAttribute('rel', 'noopener');

        const tokenField = document.createElement('input');
        tokenField.type = 'hidden';
        tokenField.name = 'token';
        tokenField.value = authStore.token;
        form.appendChild(tokenField);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };

    return (
        <div
            className={styles.apiDocsButton}
            onClick={openApiDocs}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') openApiDocs();
            }}
        >
            <span className={styles.text}>API Docs</span>
        </div>
    );
};
